import i18next from 'i18next';

i18next.addResources('es', 'EvidenceDataModal', {
  default: 'Sin información'
});
